import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Field, TextareaAutoSize, ButtonSubmit, Effects } from 'dbrain-web-ui-lib'
import AssignmentResult from '../../assignmentResult'
import './style'

const bodyClass = ['label-text-page']

class Ocr extends Component {
	constructor(props) {
		super(props)
		this.state = {
			value: '',
			txtareaError: false,
			buttonsDisabled: false,
		}
	}

	componentDidMount() {
		document.body.classList.add(...bodyClass)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.task.id !== this.props.task.id) {
			this.setState({ value: nextProps.task.userData || '' })
			const textarea = document.querySelector('.actions-inner textarea')
			if (textarea) {
				textarea.focus()
			}
		}

		this.setState({ buttonsDisabled: nextProps.isNeedToShowTaskResults })
	}

	componentWillUnmount() {
		document.body.classList.remove(...bodyClass)
	}

	handleKeyDown(event) {
		// Enter
		if (event.which === 13) {
			event.preventDefault()
			this.handleSubmitForm()
		}
	}

	handleChange(event) {
		const { value } = event.target
		this.setState({ value })
	}

	handleSubmitForm(event) {
		if (event) {
			event.preventDefault()
		}
		const data = this.form.getValues()
		if (!data.payload) {
			this.setState({ txtareaError: true })
			return
		}

		this.handleMark(data.payload)
	}

	handleMark(payload) {
		const { task, markTask } = this.props
		markTask(payload, payload, task.type)
	}

	handleNoText() {
		const data = this.form.getValues()

		if (data.payload) {
			this.setState({ txtareaError: true })
			return
		}
		this.handleMark('')
	}

	render() {
		const {
			testLabel,
			caption,
			currentTaskCaption,
			description,
			fullDescriptionPopup,
			isNeedToShowTaskResults,
			comparedResult,
			nextTask,
			rightScoreThreshold,
			task,
		} = this.props
		const { value } = this.state

		const rightResult = isNeedToShowTaskResults
			? (
				<div className="buttons taskresult">
					<AssignmentResult isRight={comparedResult.score >= rightScoreThreshold[task.type]} />

					<span
						className="taskresult-next btn"
						role="button"
						tabIndex="0"
						onClick={nextTask}
					>
						Next
					</span>
				</div>
			)
			: <ButtonSubmit className="btn btn-gray">Complete</ButtonSubmit>

		const textareaClassName = comparedResult && comparedResult.score >= rightScoreThreshold[task.type]
			? 'formitem-success'
			: 'formitem-fail'

		return (
			<div className="annotation row">
				<div className="image col-4 col-sm-4 col-xs-2">
					<img className="image-value" src={this.props.task.payload.image} alt="" />
				</div>

				<div className="actions col-2 col-sm-4 col-xs-2">
					<div className="actions-inner">
						{testLabel}
						<div className="gap-back sm-hidden" />
						{currentTaskCaption}
						{caption}
						{description}
						<div className="gap-back sm-hidden" />
						<Form
							className="textarea-form"
							onSubmit={this.handleSubmitForm.bind(this)}
							ref={(c) => { this.form = c }}
						>
							<Field className="textarea-wrapper">
								<Effects
									transition="shakeShort"
									transitionFinish={() => { this.setState({ txtareaError: false }) }}
									init={this.state.txtareaError}
								>
									<TextareaAutoSize
										autoFocus
										className={isNeedToShowTaskResults ? textareaClassName : ''}
										minRows={1}
										maxRows={5}
										disabled={this.state.buttonsDisabled}
										name="payload"
										ref={(c) => { this.payload = c }}
										value={value}
										onChange={this.handleChange.bind(this)}
										onKeyDown={this.handleKeyDown.bind(this)}
									/>
								</Effects>
							</Field>
							<Field className="buttons field-buttons">
								{rightResult}
							</Field>
						</Form>
					</div>
				</div>
				{fullDescriptionPopup}
			</div>
		)
	}
}

Ocr.defaultProps = {
	testLabel: null,
	caption: null,
	description: null,
	comparedResult: {},
}
Ocr.propTypes = {
	task: PropTypes.object.isRequired,
	markTask: PropTypes.func.isRequired,
	testLabel: PropTypes.node,
	caption: PropTypes.node,
	description: PropTypes.node,
	fullDescriptionPopup: PropTypes.node.isRequired,
	isNeedToShowTaskResults: PropTypes.bool.isRequired,
	currentTaskCaption: PropTypes.node.isRequired,
	comparedResult: PropTypes.object,
	nextTask: PropTypes.func.isRequired,
	rightScoreThreshold: PropTypes.object.isRequired,
}

export default Ocr
